import React from 'react';
import PropTypes from 'prop-types';
import { useRequestData } from 'wsm-common-data';
import VehicleMedia from '../components/VehicleMedia/VehicleMedia';
import VehicleTitle from '../components/VehicleTitle';
import VehiclePrice from '../components/VehiclePrice';
import VehicleCTA from '../components/VehicleCTA';
import ScrollToTop from '../components/ScrollToTop';
import VehiclePayment from '../components/VehiclePayment';

const ToolbarContainer = ({ isMobile, children }) => (
	<div
		className={`d-flex ${
			isMobile ? 'flex-column py-2' : 'justify-content-between py-3'
		}`}
	>
		{children}
	</div>
);

const ToolbarSection = ({ children }) => (
	<div className="d-flex align-items-center justify-content-between">
		{children}
	</div>
);

const VehicleToolbar = ({
	isVehicleGallery = false,
	vehiclePrice,
	vehicleTitle,
	vehiclePayment,
	vehicleCTAs
}) => {
	const { deviceType } = useRequestData();
	const isMobile = deviceType === 'MOBILE';

	return (
		<ToolbarContainer isMobile={isMobile}>
			<ToolbarSection>
				{!isMobile && !isVehicleGallery && (
					<VehicleMedia vehicleTitle={vehicleTitle} />
				)}
				<VehicleTitle isMobile={isMobile} vehicleTitle={vehicleTitle} />
				{isMobile && !isVehicleGallery && <ScrollToTop />}
			</ToolbarSection>
			<ToolbarSection>
				<div
					className={`flex-fill ${
						isMobile && vehiclePayment
							? 'line-height-condensed'
							: ''
					}`}
				>
					<VehiclePrice vehiclePrice={vehiclePrice} />
					{isMobile && vehiclePayment && (
						<VehiclePayment payment={vehiclePayment} />
					)}
				</div>
				{!isMobile && vehiclePayment && (
					<VehiclePayment payment={vehiclePayment} />
				)}
				<VehicleCTA
					vehicleCTAs={vehicleCTAs}
					isVehicleGallery={isVehicleGallery}
				/>
			</ToolbarSection>
		</ToolbarContainer>
	);
};

export default VehicleToolbar;

ToolbarContainer.propTypes = {
	isMobile: PropTypes.bool,
	children: PropTypes.arrayOf(PropTypes.node)
};

ToolbarSection.propTypes = {
	children: PropTypes.arrayOf(PropTypes.node)
};

VehicleToolbar.propTypes = {
	isVehicleGallery: PropTypes.bool,
	vehiclePrice: PropTypes.string,
	vehicleTitle: PropTypes.arrayOf(PropTypes.string),
	vehiclePayment: PropTypes.string,
	vehicleCTAs: PropTypes.arrayOf(PropTypes.shape({}))
};
